var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3008,
    y: 1.7002,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    fill: "#E1E1E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6152,
    y: 4.97852,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(45 26.6152 4.97852)",
    fill: "#E1E1E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 15.2998,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(90 32.3008 15.2998)",
    fill: "#E1E1E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0195,
    y: 26.6172,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(135 29.0195 26.6172)",
    fill: "#E1E1E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6992,
    y: 32.2998,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(-180 18.6992 32.2998)",
    fill: "#E1E1E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.38477,
    y: 29.0215,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(-135 7.38477 29.0215)",
    fill: "#E1E1E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.69922,
    y: 18.7002,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(-90 1.69922 18.7002)",
    fill: "#E1E1E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.98047,
    y: 7.38281,
    width: 3.4,
    height: 10.2,
    rx: 1.7,
    transform: "rotate(-45 4.98047 7.38281)",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.9db05becd7cc2e3dd94c5d53c1e9872f.svg";
export { ForwardRef as ReactComponent };